// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import MapIdFields, {
  useIdentifierFields,
} from '../../../../components/MapFields/MapIdFields';
import { fieldsToImport, ProgressIndicator, useLink } from './_config';

export default function IdentifyFields({ match }) {
  const link = useLink('identifyFields');
  const history = useHistory();
  const props = useIdentifierFields({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
    fieldsToImport,
  });

  return (
    <Layout>
      <ProgressIndicator step="mapData" />
      <PageHeader>
        <PageTitle>
          <Trans>Identify e-label</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Select the column representing Bottlebooks e-label ID.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <MapIdFields {...props} />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateIdentifierMapping();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}
